import { createCustomTheme, theme } from '../../theme';
import { VenueAttributesDTO } from '../../store/storeModels';

export const getAlteredTheme = (accountAttributes: VenueAttributesDTO) => {
  if (!accountAttributes) {
    return theme;
  }

  const primaryColor = accountAttributes.properties?.['webapp.config']?.['primary-color'] || '#45a1f8';
  const secondaryColor = accountAttributes.properties?.['webapp.config']?.['secondary-color'] || '#bfccd9';
  const textColor = accountAttributes.properties?.['webapp.config']?.['text-color'];

  return createCustomTheme({
    primaryColor,
    secondaryColor,
    textColor,
  });
};
